<template>
    <div class="d-flex justify-end">
        <div class="gtranslate_wrapper">

        </div>


    </div>
</template>

<script>
export default {

    data() {
    },
    mounted() {
        const SCRIPT_ID = 'gtranslate-script'
        window.gtranslateSettings = {
            default_language: 'fr',
            detect_browser_language: true,
            languages: ['fr', 'en'],
            wrapper_selector: '.gtranslate_wrapper',
            flag_size: 24,
            horizontal_position: 'right',
            vertical_position: 'top'
        }

        const script = document.createElement('script')
        script.id = SCRIPT_ID
        script.src = 'https://cdn.gtranslate.net/widgets/latest/fc.js'
        script.defer = true

        document.head.appendChild(script)
    },

}
</script>


<style lang="scss">
.gtranslate_wrapper {
    .gt_switcher_wrapper {
        background-color: white !important;
        padding: 5px;
        border-radius: 5px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #e0e0e0;

        a {
            color: #313d56 !important;
            text-decoration: none !important;
        }
    }

}
</style>